import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import Slider from 'react-slick';
import './Home.css';
import { featuredTop5 as featuredVideos } from '../../data/videos';


const Home = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: true
  };

  const testimonials = [
    { quote: 'TechVahini made complex topics so easy to understand. I started earning online within weeks!', name: 'Rahul Patil', role: 'Student' },
    { quote: 'Clear guidance and practical examples in Marathi. The best resource for beginners.', name: 'Pooja Deshmukh', role: 'Freelancer' },
    { quote: 'The videos and blogs are spot-on. I discovered new income streams I never knew about.', name: 'Sameer Kulkarni', role: 'Content Creator' },
    { quote: 'Loved the step-by-step approach. Very practical and easy to follow.', name: 'Neha Joshi', role: 'Entrepreneur' },
    { quote: 'High quality content in Marathi. Exactly what I needed to get started.', name: 'Amit Shinde', role: 'Digital Marketer' },
    { quote: 'Great tips and real-world insights. Helped me land my first freelance gig.', name: 'Priya K', role: 'Freelancer' },
    { quote: 'Well-structured content and consistent updates. Highly recommended!', name: 'Vikram Pawar', role: 'IT Professional' },
  ];

  return (
    <div className="home-page">
      {/* Hero Carousel */}
      <section className="hero-carousel mb-5">
        <Slider {...settings}>
          {featuredVideos.map((video) => (
            <div key={video.id} className="carousel-item">
              <a 
                className="slide-link"
                href={`https://www.youtube.com/watch?v=${video.videoId}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="carousel-content">
                  <img 
                    src={video.thumbnail} 
                    alt={video.title} 
                    className="img-fluid w-100"
                  />
                  <div className="hero-gradient" />
                  <div className="carousel-caption">
                    <h3>{video.title}</h3>
                    <p>{video.description}</p>
                    <span className="btn btn-danger btn-lg">Watch Now</span>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </Slider>
      </section>

      {/* Featured Content */}
      <Container>
        <section className="featured-section mb-5">
          <h2 className="text-center mb-4">Welcome to TechVahini</h2>
          <p className="lead text-center mb-5">
            Your ultimate destination for learning online earning methods in Marathi.
            We provide high-quality tutorials, guides, and resources to help you start
            your online journey.
          </p>

          <Row className="g-4">
            <Col md={4}>
              <Card className="h-100 shadow-sm">
                <Card.Body className="text-center">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-camera-video fs-1 text-primary"></i>
                  </div>
                  <Card.Title>Video Tutorials</Card.Title>
                  <Card.Text>
                    Step-by-step video tutorials in Marathi to help you learn various online earning methods.
                  </Card.Text>
                  <Button as={Link} to="/videos" variant="outline-primary">
                    Watch Videos
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100 shadow-sm">
                <Card.Body className="text-center">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-journal-text fs-1 text-success"></i>
                  </div>
                  <Card.Title>Detailed Blogs</Card.Title>
                  <Card.Text>
                    In-depth articles and guides covering various aspects of online earning and digital marketing.
                  </Card.Text>
                  <Button as={Link} to="/blogs" variant="outline-success">
                    Read Blogs
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100 shadow-sm">
                <Card.Body className="text-center">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-headset fs-1 text-info"></i>
                  </div>
                  <Card.Title>24/7 Support</Card.Title>
                  <Card.Text>
                    Have questions? Our support team is here to help you with any queries you might have.
                  </Card.Text>
                  <Button as={Link} to="/contact" variant="outline-info">
                    Contact Us
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </section>

        {/* Latest Videos Section */}
        <section className="latest-videos mb-5">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2>Latest Videos</h2>
            <Button as={Link} to="/videos" variant="outline-secondary">
              View All Videos
            </Button>
          </div>
          <Slider
            dots={true}
            infinite={true}
            speed={500}
            slidesToShow={3}
            slidesToScroll={1}
            autoplay={true}
            autoplaySpeed={4000}
            pauseOnHover={true}
            arrows={true}
            responsive={[
              { breakpoint: 992, settings: { slidesToShow: 2 } },
              { breakpoint: 576, settings: { slidesToShow: 1 } },
            ]}
          >
            {featuredVideos.map((video) => (
              <div key={video.id} className="px-2">
                <Card className="h-100 video-card mx-2">
                  <div className="video-thumbnail">
                    <img
                      src={video.thumbnail}
                      className="card-img-top"
                      alt={video.title}
                    />
                    <div className="play-icon">
                      <i className="bi bi-play-circle-fill"></i>
                    </div>
                  </div>
                  <Card.Body>
                    <Card.Title>{video.title}</Card.Title>
                    <Card.Text className="text-muted">{video.description}</Card.Text>
                  </Card.Body>
                  <Card.Footer>
                    <a
                      href={`https://www.youtube.com/watch?v=${video.videoId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-danger w-100"
                    >
                      Watch on YouTube
                    </a>
                  </Card.Footer>
                </Card>
              </div>
            ))}
          </Slider>
        </section>
        <section className="testimonials mb-5">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2>Testimonials</h2>
          </div>
          <Slider
            dots={true}
            infinite={true}
            speed={500}
            slidesToShow={3}
            slidesToScroll={1}
            autoplay={true}
            autoplaySpeed={4000}
            pauseOnHover={true}
            arrows={true}
            responsive={[
              { breakpoint: 992, settings: { slidesToShow: 2 } },
              { breakpoint: 576, settings: { slidesToShow: 1 } },
            ]}
          >
            {testimonials.map((t, idx) => (
              <div key={idx} className="px-2">
                <Card className="h-100 shadow-sm mx-2">
                  <Card.Body>
                    <Card.Text>“{t.quote}”</Card.Text>
                    <div className="mt-3">
                      <strong>{t.name}</strong>
                      <div className="text-muted small">{t.role}</div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </Slider>
        </section>
      </Container>
    </div>
  );
};

export default Home;
